import AppBreadcrumb from './app-breadcrumb';

export default AppBreadcrumb;